/* Kratus × Eclipse — comportamiento del panel de filtros de la colección (izquierda). [E5]
   Cuatro responsabilidades, todas delegadas en `document` porque facets.js reemplaza el DOM
   del panel entero por fetch (AJAX) en cada filtro aplicado — un bind directo a un elemento
   se perdería en el primer submit (mismo patrón que collection-controls-eclipse.js):

   1. Acordeón de "Precio" / filtros genéricos — abre/cierra con click o Enter/Espacio.
      Usa div+role=button propio (nunca <details>/<summary>): MenuDrawer (global.js) trata
      todo summary/button dentro de <menu-drawer> como un submenú de pantalla completa (con
      trapFocus y cierre del drawer entero), que es justo lo que un acordeón simple no debe
      disparar. Ver la nota larga en snippets/facets.liquid.
   2. Botón de cerrar del header — dispara el <summary> real del drawer (mismo truco que ya
      usa el botón "Aplicar" nativo de Dawn: sigue siendo el motor real quien abre/cierra).
   3. Slider de precio de dos tiradores — mejora progresiva sobre los dos campos de texto
      reales de Dawn (snippets/price-facet.liquid), sin sustituirlos ni tocar su name/value.
   4. Botón "Ver N resultados" + enlace "Eliminar todos" — el número y la visibilidad se
      recalculan cuando cambia #ProductCount (Dawn ya lo actualiza tras cada fetch, ver
      facets.js renderProductCount), porque el footer del panel no está en la lista de
      elementos que facets.js re-renderiza por AJAX. */
(function () {
  if (window.__eclipseFilterPanelBound) {
    return;
  }
  window.__eclipseFilterPanelBound = true;

  var SCOPE_SELECTOR = '.facets-container-drawer';

  /* --- 1. Acordeón --- */
  function toggleAccordion(toggle) {
    var accordion = toggle.closest('.eclipse-filter-accordion');
    var body = accordion && accordion.querySelector('[data-eclipse-accordion-body]');
    if (!body) return;
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    body.hidden = isOpen;
  }

  /* --- 3. Slider de precio --- */
  function parseAmount(raw) {
    if (!raw) return NaN;
    return Number(String(raw).replace(/,/g, ''));
  }

  function enhancePriceRange(priceRangeEl) {
    if (priceRangeEl.dataset.eclipseEnhanced === 'true') return;

    var minField = priceRangeEl.querySelector('input[name$=".gte"]');
    var maxField = priceRangeEl.querySelector('input[name$=".lte"]');
    if (!minField || !maxField) return;

    var max = parseAmount(minField.dataset.max || maxField.dataset.max);
    if (!max || Number.isNaN(max)) return;

    priceRangeEl.dataset.eclipseEnhanced = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'eclipse-price-slider';

    var track = document.createElement('div');
    track.className = 'eclipse-price-slider__track';
    var fill = document.createElement('div');
    fill.className = 'eclipse-price-slider__range';
    track.appendChild(fill);

    var minRange = document.createElement('input');
    minRange.type = 'range';
    minRange.className = 'eclipse-price-slider__input eclipse-price-slider__input--min';
    minRange.min = '0';
    minRange.max = String(max);
    minRange.step = '1';
    minRange.value = String(parseAmount(minField.value) || 0);
    minRange.setAttribute('aria-label', 'Precio mínimo');

    var maxRange = document.createElement('input');
    maxRange.type = 'range';
    maxRange.className = 'eclipse-price-slider__input eclipse-price-slider__input--max';
    maxRange.min = '0';
    maxRange.max = String(max);
    maxRange.step = '1';
    maxRange.value = String(Number.isNaN(parseAmount(maxField.value)) ? max : parseAmount(maxField.value));
    maxRange.setAttribute('aria-label', 'Precio máximo');

    wrapper.appendChild(track);
    wrapper.appendChild(minRange);
    wrapper.appendChild(maxRange);
    priceRangeEl.appendChild(wrapper);

    function paint() {
      var minV = Number(minRange.value);
      var maxV = Number(maxRange.value);
      fill.style.left = (minV / max) * 100 + '%';
      fill.style.right = 100 - (maxV / max) * 100 + '%';
    }

    function commitFromSliders() {
      minField.value = Number(minRange.value) === 0 ? '' : minRange.value;
      maxField.value = Number(maxRange.value) === max ? '' : maxRange.value;
      // "change" primero para que el PriceRange nativo de Dawn (facets.js) valide/clame los
      // valores; "input" después para que el <form> dispare el submit debounced existente.
      minField.dispatchEvent(new Event('change', { bubbles: true }));
      minField.dispatchEvent(new Event('input', { bubbles: true }));
    }

    minRange.addEventListener('input', function () {
      if (Number(minRange.value) > Number(maxRange.value)) minRange.value = maxRange.value;
      paint();
    });
    maxRange.addEventListener('input', function () {
      if (Number(maxRange.value) < Number(minRange.value)) maxRange.value = minRange.value;
      paint();
    });
    minRange.addEventListener('change', commitFromSliders);
    maxRange.addEventListener('change', commitFromSliders);

    // El usuario también puede escribir directo en los campos $ desde / $ hasta — el slider
    // se mantiene en sincronía leyendo su valor tras cada cambio.
    minField.addEventListener('change', function () {
      var value = parseAmount(minField.value);
      minRange.value = Number.isNaN(value) ? 0 : value;
      paint();
    });
    maxField.addEventListener('change', function () {
      var value = parseAmount(maxField.value);
      maxRange.value = Number.isNaN(value) ? max : value;
      paint();
    });

    paint();
  }

  function enhanceAllPriceRanges() {
    document.querySelectorAll(SCOPE_SELECTOR + ' price-range').forEach(enhancePriceRange);
  }

  /* --- 4. Footer: conteo + visibilidad del enlace de limpiar --- */
  function pluralizeResults(count) {
    return count === 1 ? 'Ver 1 resultado' : 'Ver ' + count + ' resultados';
  }

  function countActiveFilters() {
    var count = document.querySelectorAll(SCOPE_SELECTOR + ' #FacetFiltersFormMobile .mobile-facets__checkbox:checked').length;
    var priceMin = document.querySelector(SCOPE_SELECTOR + ' #FacetFiltersFormMobile input[name$=".gte"]');
    var priceMax = document.querySelector(SCOPE_SELECTOR + ' #FacetFiltersFormMobile input[name$=".lte"]');
    if ((priceMin && priceMin.value) || (priceMax && priceMax.value)) count += 1;
    return count;
  }

  function refreshFooter() {
    var countEl = document.getElementById('ProductCount');
    var button = document.querySelector(SCOPE_SELECTOR + ' [data-eclipse-view-results-button]');
    if (button) {
      var productCount = parseInt(countEl && countEl.dataset.productCount, 10);
      if (!Number.isNaN(productCount)) {
        button.textContent = pluralizeResults(productCount);
      }
    }

    var clearWrapper = document.querySelector(SCOPE_SELECTOR + ' .eclipse-filter-panel__clear-wrapper');
    if (clearWrapper) {
      clearWrapper.hidden = countActiveFilters() === 0;
    }
  }

  /* --- Observadores: el panel se reconstruye por fetch, no por mutación puntual, así que se
     re-corre la mejora del slider y el refresco del footer cada vez que cambia el conteo o el
     contenido del panel de filtros. --- */
  var productCountEl = document.getElementById('ProductCount');
  if (productCountEl) {
    new MutationObserver(refreshFooter).observe(productCountEl, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-product-count'],
    });
  }

  var filtersWrapper = document.getElementById('FacetsWrapperMobile');
  if (filtersWrapper) {
    new MutationObserver(enhanceAllPriceRanges).observe(filtersWrapper, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var accordionToggle = event.target.closest(SCOPE_SELECTOR + ' [data-eclipse-accordion-toggle]');
    if (accordionToggle) {
      toggleAccordion(accordionToggle);
      return;
    }

    if (event.target.closest(SCOPE_SELECTOR + ' [data-eclipse-filter-panel-close]')) {
      var summary = document.querySelector(SCOPE_SELECTOR + ' .mobile-facets__disclosure > summary');
      if (summary) summary.click();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var accordionToggle = event.target.closest(SCOPE_SELECTOR + ' [data-eclipse-accordion-toggle]');
    if (accordionToggle) {
      event.preventDefault();
      toggleAccordion(accordionToggle);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    enhanceAllPriceRanges();
    refreshFooter();
  });

  if (document.readyState !== 'loading') {
    enhanceAllPriceRanges();
    refreshFooter();
  }
})();
